export const path = {
  HOME: "/",
  HOMEPAGE: "/home",
};

export const CRUD_ACTIONS = {
  CREATE: "CREATE",
  UPDATE: "UPDATE",
};
export const manageActions = {
  ADD: "ADD",
  EDIT: "EDIT",
  DELETE: "DELETE",
};

export const dateFormat = {
  SEND_TO_SERVER: "DD/MM/YYYY",
};

export const YesNoObj = {
  YES: "Y",
  NO: "N",
};
export const USER_ROLE = {
  ADMIN: "R1",
  USER: "R2",
};
export const PAGINATION = {
  pagerow: 5,
};
